module.exports = __webpack_public_path__ + "img/helplogoBg02.4a1dc578.png";